// src/services/adminFeedbackService.js
import api from './api';

const getAllFeedback = async (page = 0, size = 20, sortBy = 'createdAt', sortDirection = 'desc', status = '') => {
  const params = {
    page,
    size,
    sortBy,
    sortDirection
  };
  
  if (status) {
    params.status = status;
  }
  
  const response = await api.get('/admin/feedback', { params });
  return response;
};

const getFeedbackById = async (id) => {
  const response = await api.get(`/admin/feedback/${id}`);
  return response;
};

const getFeedbackStats = async () => {
  const response = await api.get('/admin/feedback/stats');
  return response;
};

const updateFeedbackStatus = async (id, status, processedBy = 'admin', notes = '') => {
  const params = {
    status,
    processedBy,
    notes
  };
  
  const response = await api.put(`/admin/feedback/${id}/status`, null, { params });
  return response;
};

const deleteFeedback = async (id) => {
  const response = await api.delete(`/admin/feedback/${id}`);
  return response;
};

const searchFeedback = async (email = '', chitalishteName = '', feedbackType = '', page = 0, size = 20) => {
  const params = {
    email,
    chitalishteName,
    feedbackType,
    page,
    size
  };
  
  const response = await api.get('/admin/feedback/search', { params });
  return response;
};

const adminFeedbackService = {
  getAllFeedback,
  getFeedbackById,
  getFeedbackStats,
  updateFeedbackStatus,
  deleteFeedback,
  searchFeedback
};

export default adminFeedbackService;